import type { RootState } from '@/ducks/store';

export const getAuth = (state: RootState) => state.authentication.entry;
export const getAuthState = (state: RootState) => state.authentication.entry.authState;
export const getEmail = (state: RootState) => state.authentication.entry.email;
export const getIsTokenSet = (state: RootState) => state.authentication.entry.isTokenSet;
